import type { Nullable } from 'corgi-types';

import { executeGqlPersistedQuery } from './apq';
import { fetchGql } from './fetch';
import { handleGqlResponse } from './fetch/response';
import type { AssocMap, PersistedQuery } from './fetch/types';
import type { ExecuteQueryArgs } from './utils/params';
import { getGqlParams } from './utils/params';

interface ExecuteGqlQueryArgs<GqlVariables> {
  query: string;
  variables?: GqlVariables;
  assocMap?: AssocMap;
  persistedQuery?: Nullable<PersistedQuery>;
}

const executeGqlQuery = <GqlResponseData, GqlVariables>({
  query,
  variables,
  assocMap,
  persistedQuery,
}: ExecuteGqlQueryArgs<GqlVariables>) => {
  if (persistedQuery) {
    return executeGqlPersistedQuery<GqlResponseData, GqlVariables>({
      query,
      variables,
      assocMap,
      persistedQuery,
    });
  } else {
    return fetchGql<GqlResponseData, GqlVariables>({
      query,
      variables,
      assocMap,
    });
  }
};

/** @deprecated Use executeQuery with object as argument */
export function executeQuery<GqlResponseData, GqlVariables = unknown>(
  query: string,
  variables?: GqlVariables
): Promise<GqlResponseData>;

/** @deprecated Use Apollo client hooks */
export function executeQuery<GqlResponseData, GqlVariables = unknown>(
  args: ExecuteQueryArgs<GqlVariables>
): Promise<GqlResponseData>;

/** @deprecated Use Apollo client hooks */
export async function executeQuery<GqlResponseData, GqlVariables = unknown>(
  args: ExecuteQueryArgs<GqlVariables> | string,
  variables?: GqlVariables
) {
  /**
   * TODO: Remove this condition after every
   * executeQuery call is replaced with object argument
   */
  if (typeof args == 'string') {
    args = {
      query: args,
      variables,
    };
  }
  const params = await getGqlParams(args);

  return handleGqlResponse(executeGqlQuery<GqlResponseData, GqlVariables>(params));
}
